import { IonChip, IonIcon, IonLabel } from '@ionic/react'
import { useStore, useStoreMap } from 'effector-react'
import { bulb } from 'ionicons/icons'
import { useState } from 'react'
import { driverModel } from '~/entities/Driver'
import {
  AggregatorOccupationCodeEnum,
  DriverStatusEnum,
} from '~/shared/config/enums'
import { Button } from '~/shared/ui/Buttons'
import { useDrawer } from '~/shared/ui/Drawer'
import { SuccessSmallIcon } from '~/shared/ui/icons'
import { useModal } from '~/shared/ui/Modal'
import { Skeleton } from '~/shared/ui/SkeletonList'
import { ChangeCurrentOccupationModal } from './ChangeCurrentOccupationModal'
import { FillIndividualEntrepreneurDrawer } from './FillIndividualEntrepreneurDrawer'
import { SendSelfEmployedModal } from './SendSelfEmployedModal'
import { CardBlock, ListWrapper } from './styled'

export function ListDriverOccupations() {
  const driverPending = useStore(driverModel.getDriverFx.pending)
  const driverStatus = useStoreMap(driverModel.$driver, (driver) =>
    driver?.getStatus(),
  )

  const driverIsWorks = driverStatus === DriverStatusEnum.WORKS

  const [selectedOccupationId, setSelectedOccupationId] = useState<string>()

  const [
    isFillIndividualEntrepreneurDrawerShow,
    fillIndividualEntrepreneurDrawerOpen,
    fillIndividualEntrepreneurDrawerClose,
  ] = useDrawer()
  const {
    isModalShow: isChangeCurrentOccupationModalShow,
    closeModal: closeChangeCurrentOccupationModal,
    openModal: openChangeCurrentOccupationModal,
  } = useModal()
  const {
    isModalShow: isSendSelfEmployedModalShow,
    closeModal: closeSendSelfEmployedModal,
    openModal: openSendSelfEmployedModal,
  } = useModal()

  const currentOccupationId = useStoreMap(driverModel.$driver, (driver) =>
    driver?.getCurrentOccupation()?.getApiId(),
  )

  const occupations = useStoreMap(driverModel.$driver, (driver) =>
    (driver?.getOccupations() || []).map((occupation) => ({
      id: occupation.getApiId() as UniqueId,
      ...occupation?.getAttributes(),
    })),
  )

  const canFillIndividualEntrepreneur = !occupations?.some(
    (occupation) =>
      occupation.code ===
      AggregatorOccupationCodeEnum.individual_entrepreneur_rus,
  )

  const canAddSelfEmployed = !occupations?.some(
    (occupation) =>
      occupation.code === AggregatorOccupationCodeEnum.self_employed_rus,
  )

  const handleCurrentOccupationChange = (id: UniqueId) => {
    setSelectedOccupationId(id)
    openChangeCurrentOccupationModal()
  }

  if (driverPending) {
    return (
      <>
        <Skeleton animated $height={52} style={{ marginBottom: '12px' }} />
        <Skeleton animated $height={52} style={{ marginBottom: '12px' }} />
        <Skeleton animated $height={52} style={{ marginBottom: '12px' }} />
      </>
    )
  }

  return (
    <>
      {!driverIsWorks && (
        <IonChip color='warning' style={{ marginBottom: '24px' }}>
          <IonIcon icon={bulb}></IonIcon>
          <IonLabel>
            Изменить тип занятости можно только при наличии действующего
            договора
          </IonLabel>
        </IonChip>
      )}

      <ListWrapper>
        {occupations.map((occupation) => (
          <CardBlock
            data-testid={occupation.code}
            onClick={() => handleCurrentOccupationChange(occupation.id)}
            key={occupation.id}
            $selected={occupation.id === currentOccupationId}
            $disabled={occupation.id === currentOccupationId || !driverIsWorks}
          >
            <div style={{ marginRight: '6px' }}>{occupation.title}</div>
            {occupation.id === currentOccupationId && <SuccessSmallIcon />}
          </CardBlock>
        ))}
      </ListWrapper>

      {driverIsWorks && (
        <>
          {canAddSelfEmployed && (
            <Button
              fullWidth
              type='submit'
              variant='limeFlooded'
              style={{ marginBottom: '12px' }}
              onClick={openSendSelfEmployedModal}
            >
              Добавить &quot;Парковый Самозанятый&quot;
            </Button>
          )}
          {canFillIndividualEntrepreneur && (
            <Button
              fullWidth
              type='submit'
              variant='limeFlooded'
              style={{ marginBottom: '12px' }}
              onClick={fillIndividualEntrepreneurDrawerOpen}
            >
              Добавить &quot;Парковый ИП&quot;
            </Button>
          )}

          {(canFillIndividualEntrepreneur || canAddSelfEmployed) && (
            <>
              <div
                style={{
                  fontSize: '16px',
                  fontWeight: '500',
                  marginBottom: '4px',
                }}
              >
                Обратите внимание:
              </div>
              <div style={{ marginLeft: '12px' }}>
                {canAddSelfEmployed && (
                  <div style={{ fontSize: '16px', marginBottom: '4px' }}>
                    - Аккаунт с типом занятости «Парковый самозанятый» можно
                    создать только при условии, что у вас уже есть регистрация
                    как самозанятого по номеру телефона, указанному в сервисе
                    «Мой налог».
                  </div>
                )}
                {canFillIndividualEntrepreneur && (
                  <div style={{ fontSize: '16px' }}>
                    - Аккаунт с типом занятости «Парковый ИП» можно создать
                    только при условии, что вы уже зарегистрированы как
                    индивидуальный предприниматель.
                  </div>
                )}
              </div>
            </>
          )}
        </>
      )}

      <ChangeCurrentOccupationModal
        isShow={isChangeCurrentOccupationModalShow}
        onClose={closeChangeCurrentOccupationModal}
        occupationId={selectedOccupationId}
      />

      <SendSelfEmployedModal
        isShow={isSendSelfEmployedModalShow}
        onClose={closeSendSelfEmployedModal}
      />

      <FillIndividualEntrepreneurDrawer
        isShow={isFillIndividualEntrepreneurDrawerShow}
        onClose={fillIndividualEntrepreneurDrawerClose}
      />
    </>
  )
}
